import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { promotionApi } from "../api/promotionApi";
import { getPromotion } from "../../../modules/reducers/landing/promotion";
import { promotionPopupApi } from "../api/promotionPopupApi";
import { brandIdMap } from "../../Search/const/brandIdMap";

const usePromotion = () => {
  const dispatch = useDispatch();
  const landingItems = useSelector((state) => state.promotion.landingItems);
  const popUpItems = useSelector((state) => state.promotion.popUpItems);

  const storeId = useSelector((state) => state.checkArsStatus.branchId);
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(' ', '+');
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const selectedBranchId = useSelector(
    (state) => state.getBranches.selectedBranchId
  );
  const [brandCd, setBrandCd] = useState(null);
  useEffect(() => {
    setBrandCd(brandIdMap[brandId]?.cd || null);
  }, [brandId]);

  useEffect(() => {
    //   let api = promotionApi();
    // dispatch(getPromotion({ ...api, destination: "landing" }));
    if (brandCd !== null) {
      const data = {
        user_id: userId,
        biztp: brandCd,
      };
      if (selectedBranchId !== null) {
        data.store_id = selectedBranchId;
      } else if (storeId !== null) {
        data.store_id = storeId;
      }

      let api = promotionPopupApi();
      dispatch(getPromotion({ ...api, destination: "popUp", data }));
    }
  }, [brandCd, selectedBranchId]);
  return { landingItems, popUpItems };
};

export default usePromotion;
